<svg
  width="100%"
  height="222"
  viewBox="0 0 353 222"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M52.2695 179.283H65.5346V206.145C65.5346 209.808 62.5651 212.778 58.9021 212.778C55.239 212.778 52.2695 209.808 52.2695 206.145V179.283Z"
    fill="#201857"
  />
  <path
    d="M76.8105 179.283H90.0756V206.145C90.0756 209.808 87.1062 212.778 83.4431 212.778C79.78 212.778 76.8105 209.808 76.8105 206.145V179.283Z"
    fill="#201857"
  />
  <path
    d="M259.537 181.273H272.802V206.146C272.802 209.809 269.833 212.778 266.17 212.778C262.507 212.778 259.537 209.809 259.537 206.145V181.273Z"
    fill="#201857"
  />
  <path
    d="M284.078 181.273H297.343V206.146C297.343 209.809 294.374 212.778 290.711 212.778C287.048 212.778 284.078 209.809 284.078 206.145V181.273Z"
    fill="#201857"
  />
  <g filter="url(#filter0_di_551_2660)">
    <rect
      x="43.5"
      y="43.5"
      width="266"
      height="134.348"
      rx="21.5"
      stroke="white"
      stroke-width="7"
      shape-rendering="crispEdges"
    />
  </g>
  <g filter="url(#filter1_di_551_2660)">
    <rect
      x="44.8047"
      y="44.0967"
      width="263.108"
      height="132.642"
      rx="25"
      fill="#FF509F"
      fill-opacity="0.1"
      shape-rendering="crispEdges"
    />
    <rect
      x="48.3047"
      y="47.5967"
      width="256.108"
      height="125.642"
      rx="21.5"
      stroke="white"
      stroke-width="7"
      shape-rendering="crispEdges"
    />
  </g>
  <defs>
    <filter
      id="filter0_di_551_2660"
      x="0"
      y="0"
      width="353"
      height="221.348"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="20" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 1 0 0 0 0 0.227451 0 0 0 0 0.321569 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_551_2660"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_551_2660"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="2.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 1 0 0 0 0 0.227451 0 0 0 0 0.321569 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="shape"
        result="effect2_innerShadow_551_2660"
      />
    </filter>
    <filter
      id="filter1_di_551_2660"
      x="4.80469"
      y="4.09668"
      width="343.109"
      height="212.642"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="20" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.996078 0 0 0 0 0.796078 0 0 0 0 0.0941176 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_551_2660"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_551_2660"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="7.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.996078 0 0 0 0 0.796078 0 0 0 0 0.0941176 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="shape"
        result="effect2_innerShadow_551_2660"
      />
    </filter>
  </defs>
</svg>
